import {
  CreateFmtBottleLogEntity,
  FmtBottleLogEntity,
} from '@/pages/privatePages/fmtBottleLog/types';
import { BaseService } from './base.service';

class FmtBottleLogServiceClass extends BaseService<
  'fmtBottleLog',
  FmtBottleLogEntity,
  CreateFmtBottleLogEntity
> {
  constructor() {
    super('fmt-bottle-log');
  }
}
export const fmtBottleLogService = new FmtBottleLogServiceClass();
